/**
 * The model a conversation uses when nobody has chosen one.
 *
 * Shared by the server routes, the chat hook and the Settings fallback so the
 * default cannot differ by which path a user arrives through (#2253: five
 * literals said `claude-opus` while the D1 column default already said
 * `claude-sonnet`, so the answer depended on the route).
 *
 * Sonnet is the default on Akira's call, 10 Sep 2026: "we should make sonnet
 * the default." It reverses Jez's call of 6 May 2026 ("switching from sonnet
 * to opus 4.71M by default... maximum possible intelligence"), and the reason
 * he gave then has NOT stopped being true, so it is recorded here rather than
 * deleted with the comment it lived in: Crosbe staff base real production
 * decisions on this output, and Opus reasons better over cross-table joins and
 * multi-step QA aggregations, where confabulation is the expensive failure.
 * What changed is who pays. The Anthropic key is on Crosbe's account now, so
 * the cost side of that trade is the client's to weigh and Akira has weighed
 * it. Opus stays in the picker for anyone who wants it on a given question.
 *
 * Opus is the default again on Jez's call, 23 Sep 2026 (#3233): "we should
 * change the default for the analyst to opus 5.5". Automatic starts every
 * question on Opus, so Sonnet runs only when someone picks it. The cost moves
 * back to Crosbe's Anthropic account at Opus 5.5 rates, which is the trade
 * Akira weighed the other way on 10 Sep. Reversing it is this constant plus
 * the two Sonnet routes in server/lib/model-routing.ts.
 */
export const DEFAULT_MODEL = "claude-opus" as const;

/** A conversation preference that asks the server to route each question. */
export const AUTO_MODEL = "auto" as const;
